import { fetchApi } from 'api/fetchApi'
import { paths } from 'api/generated/oauth-vendors'
import { NodeHeaders } from 'api/NodeHeaders'

type Method = paths['/oauth/vendors']['get']
type Result = Method['responses']['200']['schema']

export const vendorsListApi = (headers?: NodeHeaders) =>
  fetchApi<Result>('/oauth/vendors', { headers })
